<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item>
            <el-input
              v-model.trim="queryForm.keyword"
              class="mr-10"
              clearable
              placeholder="请输入姓名/手机号"
            />
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="queryForm.levelId"
              class="mr-10"
              clearable
              placeholder="请选择会员等级"
            >
              <el-option
                v-for="item in Object.keys(levels).map((e) => ({
                  levelId: e,
                  title: levels[e],
                }))"
                :key="item.levelId"
                :label="item.title"
                :value="item.levelId"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="queryForm.agentId"
              class="mr-10"
              clearable
              placeholder="请选择渠道商"
            >
              <el-option
                v-for="item in agents"
                :key="item.agentId"
                :label="item.title"
                :value="item.agentId"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="queryForm.salesPeopleId"
              clearable
              placeholder="请选择客户经理"
            >
              <el-option
                v-for="item in roles"
                :key="item.peopleId"
                :label="`${item.basic.name}（${item.basic.customId}）`"
                :value="item.peopleId"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table v-loading="listLoading" border :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="姓名"
        prop="name"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="手机号"
        prop="tel"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="性别"
        prop="basic.sex"
        show-overflow-tooltip
        width="160px"
      >
        <template #default="{ row }">
          {{ row.basic.sex == 1 ? '先生' : '女士' }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="生日"
        prop="basic.birthday"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="会员等级"
        prop="basic.title"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ levels[row.basic.levelId] }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="健康状况"
        prop="basic.health"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ healths[row.basic.health] }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="注册日期"
        prop="created"
        show-overflow-tooltip
        width="160px"
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="85"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">修改</el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
    <import-profile ref="importProfile" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import moment from 'moment'
  import { delProfile, getProfiles, getAllLevels } from '@/api/people'
  import { getAllStaffs } from '@/api/branch'
  import Edit from './edit'
  import ImportProfile from './importProfile'

  export default {
    name: 'PeopleProfile',
    components: { Edit, ImportProfile },
    data() {
      return {
        moment,
        levels: {},
        agents: [],
        roles: [],
        healths: {
          0: '未知',
          1: '较差',
          2: '一般',
          3: '良好',
        },
        list: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        selectRows: '',
        queryForm: {
          page: 1,
          size: 10,
          keyword: '',
          levelId: '',
          agentId: '',
          salesPeopleId: '',
        },
      }
    },
    created() {
      this.getLevels()
      this.getAllStaffs()
      this.fetchData()
    },
    methods: {
      async getLevels() {
        const ret = await getAllLevels()
        ret.forEach((r) => {
          this.levels[r.levelId] = r.title
        })
      },
      async getAllStaffs() {
        this.roles = await getAllStaffs()
      },
      handleEdit(row) {
        if (row.profileId) {
          this.$refs['edit'].showEdit(row)
        } else {
          this.$refs['edit'].showEdit()
        }
      },
      handleImportProfile() {
        this.$refs['importProfile'].show()
      },
      handleDelete(row) {
        if (row.profileId) {
          this.$baseConfirm(
            `你确定要删除：${row.name}（${row.tel}）吗`,
            null,
            async () => {
              await delProfile({ profileId: row.profileId })
              this.$baseMessage(
                '删除会员成功',
                'success',
                false,
                'vab-hey-message-success'
              )
              await this.fetchData()
            }
          )
        }
      },
      handleSizeChange(val) {
        this.queryForm.size = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      queryData() {
        this.queryForm.page = 1
        this.fetchData()
      },
      async fetchData() {
        this.listLoading = true
        const { list, total } = await getProfiles(this.queryForm)
        this.list = list
        this.total = total
        this.listLoading = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .avatar {
    width: 40px;
    height: 40px;
  }
  .mr-10 {
    padding-right: 10px;
  }
</style>
